import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=user
  const [favIds, setFavIds] = useState([]);

  const loadFavs = () => api.get("/favorites/ids").then((r) => setFavIds(r.data.ids || [])).catch(() => {});

  useEffect(() => {
    api.get("/auth/me").then((r) => { setUser(r.data); loadFavs(); }).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data); loadFavs();
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data); loadFavs();
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false); setFavIds([]);
  };

  const toggleFav = async (serviceId) => {
    const { data } = await api.post(`/favorites/${serviceId}`);
    setFavIds((ids) => (data.favorite ? [...ids, serviceId] : ids.filter((i) => i !== serviceId)));
    return data.favorite;
  };
  const isFav = (id) => favIds.includes(id);

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, favIds, toggleFav, isFav }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export { formatApiError };
